import React, { useEffect, useState } from "react";
import { Box, Grid, Menu, MenuItem, Typography } from "@mui/material";

import {
  deleteAttachment,
  downloadAttachment,
  searchAttachments,
  uploadAttachment,
} from "../../api/attachments";
import { getCatalogueByCode } from "../../api/common/catalogues.ts";
import LGModalCrud from "../LGCrud/LGModalCrud";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";
import GenericFileUpload from "../Common/GenericFileUpload";

const fileOptions = [
  "Cotización",
  "Pedido"
];

export default function PurchaseOrderAttachmentsTable({ props, companyId }) {
  const { id } = props;
  const { openSnack } = useSnack();
  const [entityTypeId, setEntityTypeId] = useState(null);

  // Fetch entity type ID for Purchase Order
  useEffect(() => {
    const fetchEntityTypeId = async () => {
      try {
        const response = await getCatalogueByCode("ENTITY_PURCHASEORDER");
        setEntityTypeId(response.data.id);
      } catch (error) {
        console.error("Error fetching entity type ID:", error);
        openSnack(handleError(error), "error");
      }
    };

    fetchEntityTypeId();
  }, []);

  const handlePost = async (data) => {
    // setModalOpen(false);
    // const payload = { ...data };
    // const res = await addProviderAccounts(payload);
  };

  // Custom upload function for purchase order attachments
  const handleFileUpload = async (payload, file) => {
    if (!entityTypeId) {
      throw new Error("Entity type ID not available yet");
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("CompanyId", companyId);
    formData.append("EntityTypeId", entityTypeId.toString());
    formData.append("EntityId", id);
    formData.append("FileConcept", payload.fileConcept);
    formData.append("FileCode", payload.fileCode);

    return await uploadAttachment(formData);
  };

  const handleUpdate = async (id, data) => { };

  const handleDelete = async (uuid) => {
    try {
      await deleteAttachment(uuid);
      openSnack("Archivo eliminado correctamente", "success");
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  const handleOpenDetailClick = () => {
    console.log("Open Detail");
  };

  const handleFileDownload = async (uuid) => {
    try {
      const response = await downloadAttachment(uuid);
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "downloadedFile";

      if (
        contentDisposition &&
        contentDisposition.indexOf("attachment") !== -1
      ) {
        // Extract filename from Content-Disposition header
        const matches = contentDisposition.match(/filename="([^"]*)"/);
        if (matches && matches[1]) {
          fileName = matches[1];
        }
      }

      // Get the file extension from the filename if not available in content-disposition
      const fileExtension = fileName.split(".").pop();
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Set the download attribute with the filename including extension
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  const handleOpenContactClick = () => {
    console.log("Open Detail");
  };
  const handleOpenBankAccountClick = () => {
    console.log("Open Detail");
  };
  const handleOpenActivitiesClick = () => {
    console.log("Open Detail");
  };

  // Callback to refresh data after successful upload
  const handleUploadSuccess = () => {
    // The LGModalCrud will automatically refresh the data
    // when the modal closes, so we don't need to do anything here
  };

  // Custom fetch function for attachments
  const fetchAttachments = async (params) => {
    try {
      const filter = {
        CompanyId: companyId,
        EntityTypeId: entityTypeId, // Use the dynamic entity type ID
        EntityId: id,
        IsActive: true
      };
      const response = await searchAttachments(filter);
      return response;
    } catch (error) {
      console.error("Error fetching attachments:", error);
      return { data: [] };
    }
  };

  return (
    <>
      <Box width={"100%"}>
        {id && entityTypeId && (
          <LGModalCrud
            props={{
              actions: ["create", "download", "delete"],
              data: { purchaseOrderId: id, companyId: companyId },
              fetchFunction: fetchAttachments,
              deleteFunction: handleDelete,
              downloadFunction: handleFileDownload,
              columns: [
                {
                  field: "fileConcept",
                  headerName: "Concepto del archivo",
                  flex: 0.3,
                },
                {
                  field: "fileCode",
                  headerName: "Código",
                  flex: 0.2,
                },
                {
                  field: "originalFileName",
                  headerName: "Nombre del archivo",
                  flex: 0.3,
                },
                {
                  field: "sizeBytes",
                  headerName: "Tamaño",
                  flex: 0.1,
                  valueGetter: (value) => {
                    const bytes = value;
                    if (bytes === 0) return "0 Bytes";
                    const k = 1024;
                    const sizes = ["Bytes", "KB", "MB", "GB"];
                    const i = Math.floor(Math.log(bytes) / Math.log(k));
                    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
                  },
                },
                {
                  field: "createdAt",
                  headerName: "Fecha de subida",
                  flex: 0.2,
                  valueGetter: (value) => {
                    return new Date(value).toLocaleDateString();
                  },
                },
              ],
              addModalData: {
                header: "Agregar Documentos",
                body: (
                  <GenericFileUpload
                    fileNameOptions={fileOptions}
                    uploadFunction={handleFileUpload}
                    id={id}
                    onSubmit={handleUploadSuccess}
                  />
                ),
              },
              editModalData: {
                header: "Editar Archivo",
                body: <p>Formulario editar archivo</p>,
              },
            }}
          />
        )}
      </Box>
    </>
  );
}
